import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  CHECKIN_PASSENGER_ADDITION_RESULT_STORE_NAME,
  CheckinPassengerAdditionResultState,
} from './checkin-passenger-addition-result.state';

/** Select CheckinPassengerAdditionResult State */
export const selectCheckinPassengerAdditionResultState = createFeatureSelector<CheckinPassengerAdditionResultState>(
  CHECKIN_PASSENGER_ADDITION_RESULT_STORE_NAME
);

/** Select CheckinPassengerAdditionResult isPending status */
export const selectCheckinPassengerAdditionResultIsPendingStatus = createSelector(
  selectCheckinPassengerAdditionResultState,
  (state) => !!state.isPending
);

/** Select CheckinPassengerAdditionResult isFailure status */
export const selectCheckinPassengerAdditionResultIsFailureStatus = createSelector(
  selectCheckinPassengerAdditionResultState,
  (state) => !!state.isFailure
);
